module.exports = __webpack_public_path__ + "assets/dd4eab9de8c5191b546d3d3e2ea40bf7.png";